import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { AppServices } from 'middleware'
import { NewServiceApp, ServiceApp, ServiceAppWithSecret } from './schema'

export const serviceAppsApi = createApi({
    reducerPath: 'serviceAppsApi',
    tagTypes: ['serviceApps'],
    baseQuery: fetchBaseQuery({}),
    endpoints: () => ({}),
})

export const extendedServiceAppsApi = serviceAppsApi.injectEndpoints({
    endpoints: (builder) => ({
        getServiceApps: builder.query<ServiceApp[], void>({
            queryFn: async () => {
                try {
                    const data = await AppServices.serviceAppsService.list()
                    return { data }
                } catch (error) {
                    return { error }
                }
            },
            providesTags: ['serviceApps'],
        }),
        createServiceApp: builder.mutation<ServiceAppWithSecret, NewServiceApp>({
            invalidatesTags: ['serviceApps'],
            queryFn: async (app) => {
                try {
                    const data = await AppServices.serviceAppsService.create(app)
                    return { data }
                } catch (error) {
                    return { error }
                }
            },
        }),
        rotateServiceAppSecret: builder.mutation<ServiceAppWithSecret, string>({
            invalidatesTags: ['serviceApps'],
            queryFn: async (clientId) => {
                try {
                    const data = await AppServices.serviceAppsService.rotateSecret(clientId)
                    return { data }
                } catch (error) {
                    return { error }
                }
            },
        }),
        revokeServiceApp: builder.mutation<void, string>({
            invalidatesTags: ['serviceApps'],
            queryFn: async (clientId) => {
                try {
                    await AppServices.serviceAppsService.revoke(clientId)
                    return { data: undefined }
                } catch (error) {
                    return { error }
                }
            },
        }),
    }),
})

export const { reducer, reducerPath } = serviceAppsApi
export const {
    useGetServiceAppsQuery,
    useCreateServiceAppMutation,
    useRotateServiceAppSecretMutation,
    useRevokeServiceAppMutation,
} = extendedServiceAppsApi
